/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Message } from '../models';
/**
 * CryptoService - axios parameter creator
 * @export
 */
export const CryptoServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert eine Liste von Verschlüsselten Ids
         * @summary EncryptIds
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncryptedIds: async (ids: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('getEncryptedIds', 'ids', ids)
            const localVarPath = `/api/jasper-print/encrypt-ids/{ids}`
                .replace(`{${"ids"}}`, encodeURIComponent(String(ids)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CryptoService - functional programming interface
 * @export
 */
export const CryptoServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CryptoServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert eine Liste von Verschlüsselten Ids
         * @summary EncryptIds
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEncryptedIds(ids: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEncryptedIds(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CryptoService - factory interface
 * @export
 */
export const CryptoServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CryptoServiceFp(configuration)
    return {
        /**
         * Liefert eine Liste von Verschlüsselten Ids
         * @summary EncryptIds
         * @param {string} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEncryptedIds(ids: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getEncryptedIds(ids, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CryptoService - interface
 * @export
 * @interface CryptoService
 */
export interface CryptoServiceInterface {
    /**
     * Liefert eine Liste von Verschlüsselten Ids
     * @summary EncryptIds
     * @param {string} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CryptoServiceInterface
     */
    getEncryptedIds(ids: string, options?: any): AxiosPromise<Array<string>>;

}

/**
 * CryptoService - object-oriented interface
 * @export
 * @class CryptoService
 * @extends {BaseAPI}
 */
export class CryptoService extends BaseAPI implements CryptoServiceInterface {
    /**
     * Liefert eine Liste von Verschlüsselten Ids
     * @summary EncryptIds
     * @param {string} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CryptoService
     */
    public getEncryptedIds(ids: string, options?: any) {
        return CryptoServiceFp(this.configuration).getEncryptedIds(ids, options).then((request) => request(this.axios, this.basePath));
    }
}
